
import formGroupOriginAccess from './formGroupOriginAccess';
import formGroupOriginCredentialsEdit from './formGroupOriginCredentialsEdit';
import formGroupOriginDetailEdit from './formGroupOriginDetailEdit';

export default {
  title: 'Origin Edit',
  attributeName: 'origin',
  createURL: 'origin',
  sessionParams: [],
  getURL: 'origin',
  refreshURL: 'origin',
  updateURL: 'origin',
  idAttribute: 'id',
  saveIdSessionNameAs: 'originId',
  noArea: true,
  goBack: true,
  websocketChannel: 'originDetails-originId',
  websocketSessionParams: ['originId'],
  websocketItem: 'originDetails',
  formConfig: [
    formGroupOriginDetailEdit,
    formGroupOriginCredentialsEdit,
    formGroupOriginAccess
  ],
};
